var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"perk-item"},[_c('div',{staticClass:"perk-item-picture"},[_c('div',{staticClass:"perk-item-picture-cnt"},[_c('img',{attrs:{"src":_vm.picture,"alt":"Picture"}})])]),_c('div',{staticClass:"perk-item-txt"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }